import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { DotLoadingIndicator } from '@xing-com/dot-loading-indicator';

import * as Styled from './encoding.styles';
import icon from './encoding.svg';

export const Encoding: FC = () => {
  return (
    <Styled.Wrapper>
      <Styled.Image src={icon} alt="encoding" />
      <Styled.TitleSpinnerWrapper>
        <Styled.Title>
          <FormattedMessage id="VIDEO_ENCODING_HEADLINE" />
        </Styled.Title>
        <Styled.SpinnerWrapper>
          <DotLoadingIndicator />
        </Styled.SpinnerWrapper>
      </Styled.TitleSpinnerWrapper>
      <Styled.Description>
        <FormattedMessage id="VIDEO_ENCODING_MESSAGE" />
      </Styled.Description>
    </Styled.Wrapper>
  );
};
